import React from 'react';

export default function PlacesIcon() {
  return (
  	<svg width="71" height="74" viewBox="0 0 71 74" fill="none" xmlns="http://www.w3.org/2000/svg">
  		<path fillRule="evenodd" clipRule="evenodd" d="M35.5001 18.5C27.4376 18.5 20.9167 25.2556 20.9167 33.6083C20.9167 44.9396 35.5001 61.6667 35.5001 61.6667C35.5001 61.6667 50.0834 44.9396 50.0834 33.6083C50.0834 25.2556 43.5626 18.5 35.5001 18.5ZM35.5001 40.0833C32.2801 40.0833 29.6667 37.3207 29.6667 33.9167C29.6667 30.5127 32.2801 27.75 35.5001 27.75C38.7201 27.75 41.3334 30.5127 41.3334 33.9167C41.3334 37.3207 38.7201 40.0833 35.5001 40.0833Z" fill="#E94E32"/>
  	</svg>
  );
}
